import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { deleteData, getData, patchData, postData } from "src/utils/axios/serverHelper";
import { KSK2080_R01Filter } from "./Store_KSK2080_R01";
import { KSK2080_R01Dto } from "./Dto_KSK2080_R01";

const noticeUrl = `${config.apiUrl}/KSK2080_R01`;


export const getKSK2080_R01List = async ( option: string, params: Partial<KSK2080_R01Filter>, listLength: number = 0) => {
	const url = `${noticeUrl}/${option}`;

	return await getData<ResponseDto<KSK2080_R01Dto[]>>(url, { params: {
		...params,
		listLength
	} })
}

export const getKSK2080_R01TopNotice = async ( option: string, params: Partial<KSK2080_R01Filter>, listLength: number = 0) => {
	const url = `${noticeUrl}/top${option}`;

	return await getData<ResponseDto<KSK2080_R01Dto[]>>(url, { params: {
		...params,
		listLength
	} })
}

export const getKSK2080_R01AllCount = async (params: Partial<KSK2080_R01Filter>) => {
    const url = `${noticeUrl}/allCount`;
    return await getData<ResponseDto<number>>(url, {
        params: {
            ...params
        }
    });
}	

export const getKSK2080_R01One = async (notice_no: string) => {
	const url = `${noticeUrl}/one/${notice_no}`;

	return await getData<ResponseDto<KSK2080_R01Dto>>(url);
}


export const createKSK2080_R01 = async (data: KSK2080_R01Dto) => {

	return await postData<KSK2080_R01Dto, ResponseDto<KSK2080_R01Dto[]>>(noticeUrl, data);
}

export const patchKSK2080_R01 = async (data: KSK2080_R01Dto) => {

	return await patchData<KSK2080_R01Dto, ResponseDto<KSK2080_R01Dto[]>>(noticeUrl, data);
}

export const deleteKSK2080_R01 = async (itemCd: string) => {
	const url = `${noticeUrl}/${itemCd}`;

	return await deleteData<ResponseDto<any>>(url);
}

export const downloadExcel_KSK2080_R01 = async ( option: string, params: Partial<KSK2080_R01Filter>, listLength: number = 0) => {

	const url = `${noticeUrl}/excel/${option}`;

	return await getData<ResponseDto<string>>(url, { params: {
		...params,
		listLength
	} })
}